import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbPaginatedResponse } from '@galabid/gb-dashboard/core/data-access'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import {
  BulkDeleteEventTicketPackagesResponse,
  BulkUpdateEventTicketPackagesPayload,
  EventTicketPackageEntity,
  ReorderEventTicketPackagesResponse,
} from './event-ticket-packages.models'

@Injectable({
  providedIn: 'root',
})
export class EventTicketPackagesApiService extends GbApiService {
  getEventTicketPackages(
    urlName = '',
    offset: number,
    searchTerm?: string,
    order?: string,
    limit = this.appConfig.itemsPageSize,
  ): Observable<GbPaginatedResponse<EventTicketPackageEntity>> {
    let params = new HttpParams().set('limit', limit).set('offset', offset)
    if (searchTerm) params = params.set('search', searchTerm)
    if (order) params = params.set('ordering', order)

    return this.get<GbPaginatedResponse<EventTicketPackageEntity>>(`auctions/${urlName}/event-ticket-packages/`, {
      params,
    })
  }

  syncEventTicketPackage(urlName = '', uuid: string): Observable<EventTicketPackageEntity> {
    return this.get<EventTicketPackageEntity>(`auctions/${urlName}/event-ticket-packages/${uuid}/`)
  }

  createEventTicketPackage(
    eventTicketPackage: Partial<EventTicketPackageEntity>,
  ): Observable<EventTicketPackageEntity> {
    const url = `auctions/${eventTicketPackage.auction}/event-ticket-packages/`
    return this.post<EventTicketPackageEntity>(url, eventTicketPackage)
  }

  bulkUpdateEventTicketPackages(urlName = '', payload: BulkUpdateEventTicketPackagesPayload): Observable<void> {
    return this.post<void>(`auctions/${urlName}/event-ticket-packages/bulk-update/`, payload)
  }

  bulkDeleteEventTicketPackages(
    urlName = '',
    ticketPackages: string[],
  ): Observable<BulkDeleteEventTicketPackagesResponse> {
    return this.post<BulkDeleteEventTicketPackagesResponse>(`auctions/${urlName}/event-ticket-packages/bulk-delete/`, {
      ticket_packages: ticketPackages,
    })
  }

  updateEventTicketPackage(eventTicketPackage: EventTicketPackageEntity): Observable<EventTicketPackageEntity> {
    const url = `auctions/${eventTicketPackage.auction}/event-ticket-packages/${eventTicketPackage.uuid}/`
    return this.patch<EventTicketPackageEntity>(url, eventTicketPackage)
  }

  deleteEventTicketPackage(urlName = '', uuid: string): Observable<void> {
    const url = `auctions/${urlName}/event-ticket-packages/${uuid}/`
    return this.delete<void>(url)
  }

  reorderEventTicketPackages(
    urlName = '',
    start: number,
    uuids: string[],
  ): Observable<ReorderEventTicketPackagesResponse> {
    const url = `auctions/${urlName}/event-ticket-packages/reorder/`
    return this.post<ReorderEventTicketPackagesResponse>(url, { start, ticket_packages: uuids })
  }
}
